export default {"src":"/_next/static/media/Rio.1083a080.svg","height":73,"width":60};